import * as React from 'react';
import { useStore } from '../state/store';

interface Props { onRestart: () => void; }

export function GameOver({ onRestart }: Props) {
  const score = useStore((s) => s.score);
  const hiScore = useStore((s) => s.hiScore);
  const lossReason = useStore((s) => s.lossReason);
  const maxCombo = useStore((s) => s.maxCombo);
  const earned = useStore((s) => s.creditsEarnedThisRun);
  const wave = useStore((s) => s.wave);
  const bestWave = useStore((s) => s.prog.bestWave);
  const won = useStore((s) => s.phase === 'victory');
  const setPhase = useStore((s) => s.setPhase);

  const headline = won ? 'VICTORY' : lossReason === 'villages' ? 'NO VILLAGES LEFT' : 'SHOT DOWN';
  const subline = won
    ? 'You held the line — every war machine destroyed.'
    : lossReason === 'villages'
      ? 'The enemy wiped out every settlement.'
      : 'Your whole force has been destroyed.';

  return (
    <div
      style={{
        position: 'absolute', inset: 0,
        background: won ? 'rgba(8,28,14,0.7)' : 'rgba(0,0,0,0.6)',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        color: '#fff',
        pointerEvents: 'auto',
        fontSize: 18,
        gap: 10,
      }}>
      <div style={{ fontSize: 42, letterSpacing: 4, fontWeight: 700, color: won ? '#7cf09a' : '#fff' }}>{headline}</div>
      <div style={{ opacity: 0.85, fontSize: 14, letterSpacing: 1 }}>{subline}</div>
      <div style={{ opacity: 0.9, marginTop: 8 }}>WAVE REACHED <b>{wave}</b> · BEST <b>{Math.max(bestWave, wave)}</b></div>
      <div style={{ opacity: 0.9 }}>SCORE <b>{score.toLocaleString()}</b></div>
      <div style={{ opacity: 0.9 }}>HIGH SCORE <b>{Math.max(hiScore, score).toLocaleString()}</b></div>
      <div style={{ opacity: 0.9 }}>MAX COMBO <b>×{maxCombo}</b></div>
      <div style={{ marginTop: 6, color: '#ffd24a', fontWeight: 700 }}>◈ +{earned.toLocaleString()} cr earned</div>
      <div style={{ display: 'flex', gap: 12, marginTop: 22 }}>
        <button
          onClick={() => setPhase('hangar')}
          style={btn('#2e6da4')}>⚙ HANGAR</button>
        <button
          onClick={() => onRestart()}
          style={btn('#2e8b57')}>RETRY ▸</button>
      </div>
    </div>
  );
}

function btn(bg: string): React.CSSProperties {
  return {
    background: bg, color: '#fff', border: 'none', borderRadius: 6,
    padding: '12px 22px', fontFamily: 'inherit', fontSize: 15, fontWeight: 700,
    letterSpacing: 2, cursor: 'pointer',
  };
}
